module.exports = __webpack_public_path__ + "img/711.bf480715.jpg";